module.exports = __webpack_public_path__ + "r-v3/img/notice_white.7c1292ec.svg";